import { render, staticRenderFns } from "./SMTPSettings.vue?vue&type=template&id=2470bebe&"
import script from "./SMTPSettings.vue?vue&type=script&lang=js&"
export * from "./SMTPSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports